const PHOTO_KEYS = ['avatar_url', 'avatarUrl', 'picture', 'photo', 'photo_url'] as const;

function photoFrom(bag: unknown): string {
  if (!bag || typeof bag !== 'object') return '';
  const record = bag as Record<string, unknown>;
  for (const key of PHOTO_KEYS) {
    const value = record[key];
    if (typeof value === 'string' && /^https?:\/\//i.test(value.trim())) return value.trim();
  }
  return '';
}

/**
 * Same picture the provider sent at sign-in. Used by the top bar and stored
 * on the session so it matches the campaign faces, which resolve this on the server.
 */
export function oauthAvatarUrl(user: any): string {
  if (!user) return '';
  const direct = photoFrom(user) || photoFrom(user.user_metadata);
  if (direct) return direct;
  const identities = Array.isArray(user.identities) ? user.identities : [];
  for (const identity of identities) {
    const fromIdentity = photoFrom(identity?.identity_data);
    if (fromIdentity) return fromIdentity;
  }
  return '';
}
